<template>
    <v-card
            class="pa-1 mb-1" style="cursor: pointer"
            :color="color"
            @mouseover="visibleItem = true" @mouseleave="visibleItem = false"
    >
        <v-container fluid class="py-0">
        <v-row>
            <v-col cols="10" class="px-0">
                <v-list-item class="px-0">
                    <v-list-item-content class="pa-1 ma-0 body-2">
                        <v-list-item-title class="title body-2">
                            {{mailing.title}}
                        </v-list-item-title>
                        <v-list-item-subtitle class="title body-2">
                            Подписчиков: {{mailing.count}}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="title body-2">
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col cols="2" class="pl-0">
                <v-btn x-small icon color="primary" @click="$emit('editMailing', index)"
                       v-if="status !=='success'"
                       v-show="visibleItem && mailing.id != 1 && mailing.id!== 0"
                >
                    <v-icon small>edit</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        </v-container>
    </v-card>
</template>

<script>

export default {
    data () {
        return {
            visibleItem: false
        }
    },
    props: ['mailing', 'index', 'status', 'selected'],
    methods: {
        editMailing() {
            this.$emit('editMailing', this.index)
        },
        async removeMailing() {
            let res = await this.$dialog['error']({
                title: 'Подтверждение удаления',
                text: 'Вы действительно хотите удалить?',
                persistent: this.persistent,
                actions: {
                    false: 'Отмена',
                    true: {
                        color: 'red',
                        text: 'Подтверждаю',
                        handle: () => {
                            return new Promise(resolve => {
                                setTimeout(resolve, 300)
                            })
                        }
                    }
                }
            })
            if (res !== undefined && res !== false) {

            }
        },
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        }
    },
    computed: {
        color() {
            return this.selected ? 'blue lighten-2' : ''
        }
    }
}
</script>

<style scoped>

</style>
